import React from "react";

const CategoriesScrollCard = ({ card }) => {

    // Function to handle navigation
    const navigateToBrandsCategories = (url) => {
        if (url) navigate(url);
    };
    const navigate = (data) => {
        if (data.NavigationType === "3") {
            const currentQueryParams = window.location.search;

            if (data.FSN === "103") {
                localStorage.setItem("productId", data.FAI.productId);
                localStorage.setItem("FSN", data.FSN);
                window.location.href = `/product_detail_page${currentQueryParams}`; // Query params mat daal, localStorage se kaam hoga
              } else if (data.FSN === "125") {
                localStorage.setItem("type", data.FAI.type);
                localStorage.setItem("typeId", data.FAI.typeId);
                localStorage.setItem("FSN", data.FSN);
                window.location.href = `/store_category_grid_page${currentQueryParams}`; // Query params mat daal, localStorage se kaam hoga
              }
        }
    };

    return (
        <div className="p-3">
            <h2 className="text-lg font-semibold" style={{ color: "#681517" }}>{card?.cardMetaData?.title}</h2>
            <div className="flex overflow-x-auto gap-3 scrollbar-hide">
                {card?.cardData.map((category, index) => (
                    <div key={index}>
                        <img
                            onClick={() => navigateToBrandsCategories(category.data.onTap)}
                            src={category.data.imageUrl}
                            alt={`Category ${index + 1}`}
                            height={category.data.shapeType == "squareSmall" ? "100px" : "250px"}
                            style={{ cursor: "pointer", borderRadius: "8px" }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CategoriesScrollCard;
